import {
	deserializeLocalStorageValue,
	getOnBoardingAccessTokenKey,
	getSessionOidcAuthKey,
} from '@shared/utils';

import type { ApiRequestOptions } from './lib/core/ApiRequestOptions';
import { OpenAPI } from './lib/index';

OpenAPI.BASE = import.meta.env.VITE_ORGANIZATION_API_BASE_URL || '/';
OpenAPI.HEADERS = (options: ApiRequestOptions) =>
	new Promise((resolve) => {
		if (typeof window === 'undefined') {
			// Node.js environment
			console.log('Running in Node.js environment');
			const accessToken = import.meta.env.VITE_ORGANIZATION_API_ACCESS_TOKEN;
			resolve({
				Authorization: `Bearer ${accessToken}`,
			});
		} else {
			// Browser environment
			//console.log('Running in Browser environment');
			const sessionOidcAuthKey = getSessionOidcAuthKey();
			let accessToken =
				deserializeLocalStorageValue<any>(sessionOidcAuthKey)?.access_token ||
				'';

			/* Handle onboarding with onboarding access token */
			const accessTokenKey = getOnBoardingAccessTokenKey();
			if (
				['/onboarding/member', '/onboarding/invitation'].some((path) =>
					options.url.includes(path)
				)
			) {
				accessToken = deserializeLocalStorageValue<any>(accessTokenKey) || '';
			} else if (
				['/organizations/'].some((path) => options.url.includes(path)) &&
				options.method === 'PUT'
			) {
				accessToken =
					deserializeLocalStorageValue<any>(accessTokenKey) || accessToken;
			}

			resolve({
				Authorization: `Bearer ${accessToken}`,
			});
		}
	});

export * from './lib/index';
